import { render, staticRenderFns } from "./message-link.vue?vue&type=template&id=9e7a04b6&"
import script from "./message-link.vue?vue&type=script&lang=js&"
export * from "./message-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports